module.exports = __webpack_public_path__ + "/images/shop/carpage-car-selection/nat_code2.jpg";